import local from './local';
import dev from './dev';
import d2 from './d2';
import staging from './staging';
import production from './production';

export const getConfig = () => {
  if (window.location.host.endsWith('dev.moo.com')) {
    return dev;
  }

  if (window.location.host.endsWith('d2.moocrews.com')) {
    return d2;
  }

  if (window.location.host.endsWith('staging.moo.com')) {
    return staging;
  }

  if (window.location.host.endsWith('moo.com')) {
    return production;
  }

  return local;
};

export default getConfig();
